import { useMemo, useState } from "react";
import { FileDown, Loader2 } from "lucide-react";
import { toast } from "sonner";
import Tip from "../components/Tip";

const API = process.env.REACT_APP_BACKEND_URL;
const MONTHS_IT = ["gennaio","febbraio","marzo","aprile","maggio","giugno","luglio","agosto","settembre","ottobre","novembre","dicembre"];

export default function FinancesReports() {
  const now = new Date();
  const [year, setYear] = useState(now.getFullYear());
  const [month, setMonth] = useState(now.getMonth() + 1);
  const [busy, setBusy] = useState(false);

  const months12 = useMemo(() => {
    const arr = [];
    const d = new Date(now.getFullYear(), now.getMonth(), 1);
    for (let i = 0; i < 12; i++) {
      arr.push({ y: d.getFullYear(), m: d.getMonth() + 1, label: `${MONTHS_IT[d.getMonth()].charAt(0).toUpperCase() + MONTHS_IT[d.getMonth()].slice(1)} ${d.getFullYear()}` });
      d.setMonth(d.getMonth() - 1);
    }
    return arr;
    // eslint-disable-next-line
  }, []);

  const download = async () => {
    setBusy(true);
    try {
      const monthStr = `${year}-${String(month).padStart(2, "0")}`;
      // Serve auth: uso il token da localStorage in header
      const token = localStorage.getItem("pxos.token");
      const res = await fetch(`${API}/api/finances/pdf-report?month=${monthStr}`, {
        headers: { Authorization: `Bearer ${token}` },
        credentials: "include",
      });
      if (!res.ok) throw new Error(`HTTP ${res.status}`);
      const blob = await res.blob();
      const url = URL.createObjectURL(blob);
      const a = document.createElement("a");
      a.href = url; a.download = `finanze_${monthStr}.pdf`;
      document.body.appendChild(a); a.click(); a.remove();
      URL.revokeObjectURL(url);
      toast.success("PDF scaricato");
    } catch (e) {
      toast.error(`Errore generazione PDF: ${e.message}`);
    } finally { setBusy(false); }
  };

  return (
    <div className="space-y-6" data-testid="finances-reports-page">
      <div>
        <div className="text-xs font-mono uppercase tracking-widest opacity-70">Finanze · Report</div>
        <h1 className="mt-1 font-display text-3xl sm:text-4xl font-semibold">Report PDF mensile</h1>
        <p className="mt-2 text-sm opacity-80 max-w-2xl">
          Genera un report PDF A4 con riepilogo entrate, uscite pagate/pending, costi fissi e dati mancanti per il mese selezionato.
        </p>
      </div>

      <div className="pxos-card p-5 space-y-4 max-w-xl">
        <label className="block">
          <span className="text-xs uppercase opacity-70 tracking-widest">Mese</span>
          <select
            className="pxos-input"
            value={`${year}-${month}`}
            onChange={(e) => { const [y, m] = e.target.value.split("-"); setYear(+y); setMonth(+m); }}
            data-testid="reports-month-select"
          >
            {months12.map((x) => (
              <option key={`${x.y}-${x.m}`} value={`${x.y}-${x.m}`}>{x.label}</option>
            ))}
          </select>
        </label>
        <Tip label="Scarica il PDF del mese selezionato">
          <button
            onClick={download}
            disabled={busy}
            className="pxos-btn-primary inline-flex items-center gap-2 disabled:opacity-50"
            data-testid="reports-download-btn"
          >
            {busy ? <Loader2 size={14} className="animate-spin" /> : <FileDown size={14} />}
            {busy ? "Generazione…" : "Scarica PDF"}
          </button>
        </Tip>
      </div>

      <div className="text-xs opacity-70 max-w-2xl">
        Il PDF viene generato al momento con i dati reali del database. I calcoli si basano solo sui dati inseriti da te — nessun importo viene inventato.
      </div>
    </div>
  );
}
